var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_502)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 58,
    height: 58,
    rx: 5.94872,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.37179,
    y: 6.37179,
    width: 57.2564,
    height: 57.2564,
    rx: 5.57692,
    stroke: "#001B34",
    strokeWidth: 0.74359
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3413 28.3333C27.3413 27.6261 27.6223 26.9478 28.1224 26.4477C28.6225 25.9476 29.3008 25.6667 30.008 25.6667H46.008C46.7152 25.6667 47.3935 25.9476 47.8936 26.4477C48.3937 26.9478 48.6747 27.6261 48.6747 28.3333V32.3333C48.6747 33.0406 48.3937 33.7189 47.8936 34.219C47.3935 34.719 46.7152 35 46.008 35H30.008C29.3008 35 28.6225 34.719 28.1224 34.219C27.6223 33.7189 27.3413 33.0406 27.3413 32.3333V28.3333ZM46.008 28.3333H30.008V32.3333H46.008V28.3333ZM42.008 37.6667C41.3008 37.6667 40.6225 37.9476 40.1224 38.4477C39.6223 38.9478 39.3413 39.6261 39.3413 40.3333V43C39.3413 43.7072 39.6223 44.3855 40.1224 44.8856C40.6225 45.3857 41.3008 45.6667 42.008 45.6667H46.008C46.7152 45.6667 47.3935 45.3857 47.8936 44.8856C48.3937 44.3855 48.6747 43.7072 48.6747 43V40.3333C48.6747 39.6261 48.3937 38.9478 47.8936 38.4477C47.3935 37.9476 46.7152 37.6667 46.008 37.6667H42.008ZM42.008 40.3333H46.008V43H42.008V40.3333ZM27.3413 39C27.3413 38.6464 27.4818 38.3072 27.7319 38.0572C27.9819 37.8071 28.321 37.6667 28.6747 37.6667H35.3413C35.695 37.6667 36.0341 37.8071 36.2841 38.0572C36.5342 38.3072 36.6747 38.6464 36.6747 39C36.6747 39.3536 36.5342 39.6928 36.2841 39.9428C36.0341 40.1929 35.695 40.3333 35.3413 40.3333H28.6747C28.321 40.3333 27.9819 40.1929 27.7319 39.9428C27.4818 39.6928 27.3413 39.3536 27.3413 39ZM28.6747 43C28.321 43 27.9819 43.1405 27.7319 43.3905C27.4818 43.6406 27.3413 43.9797 27.3413 44.3333C27.3413 44.687 27.4818 45.0261 27.7319 45.2761C27.9819 45.5262 28.321 45.6667 28.6747 45.6667H35.3413C35.695 45.6667 36.0341 45.5262 36.2841 45.2761C36.5342 45.0261 36.6747 44.687 36.6747 44.3333C36.6747 43.9797 36.5342 43.6406 36.2841 43.3905C36.0341 43.1405 35.695 43 35.3413 43H28.6747ZM28.6667 19C26.8986 19 25.2029 19.7024 23.9526 20.9526C22.7024 22.2029 22 23.8986 22 25.6667V44.3333C22 46.1014 22.7024 47.7971 23.9526 49.0474C25.2029 50.2976 26.8986 51 28.6667 51H47.3333C49.1014 51 50.7971 50.2976 52.0474 49.0474C53.2976 47.7971 54 46.1014 54 44.3333V25.6667C54 23.8986 53.2976 22.2029 52.0474 20.9526C50.7971 19.7024 49.1014 19 47.3333 19H28.6667ZM24.6667 25.6667C24.6667 24.6058 25.0881 23.5884 25.8382 22.8382C26.5884 22.0881 27.6058 21.6667 28.6667 21.6667H47.3333C48.3942 21.6667 49.4116 22.0881 50.1618 22.8382C50.9119 23.5884 51.3333 24.6058 51.3333 25.6667V44.3333C51.3333 45.3942 50.9119 46.4116 50.1618 47.1618C49.4116 47.9119 48.3942 48.3333 47.3333 48.3333H28.6667C27.6058 48.3333 26.5884 47.9119 25.8382 47.1618C25.0881 46.4116 24.6667 45.3942 24.6667 44.3333V25.6667Z",
    fill: "#001B34"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_502",
    x: 0.0769234,
    y: 0.0512824,
    width: 75.8462,
    height: 75.8462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.97436
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(22 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.9d72bdc178f3263e39607edd3ca072a1.svg";
export { ForwardRef as ReactComponent };